export enum USStates {
  Alabama = 'AL',
  Alaska = 'AK',
  AmericanSamoa = 'AS',
  Arizona = 'AZ',
  Arkansas = 'AR',
  ArmedForcesAmericas = 'AA',
  ArmedForcesEurope = 'AE',
  ArmedForcesPacific = 'AP',
  California = 'CA',
  Colorado = 'CO',
  Connecticut = 'CT',
  Delaware = 'DE',
  DistrictOfColumbia = 'DC',
  Florida = 'FL',
  Georgia = 'GA',
  Guam = 'GU',
  Hawaii = 'HI',
  Idaho = 'ID',
  Illinois = 'IL',
  Indiana = 'IN',
  Iowa = 'IA',
  Kansas = 'KS',
  Kentucky = 'KY',
  Louisiana = 'LA',
  Maine = 'ME',
  Maryland = 'MD',
  Massachusetts = 'MA',
  Michigan = 'MI',
  Minnesota = 'MN',
  Mississippi = 'MS',
  Missouri = 'MO',
  Montana = 'MT',
  Nebraska = 'NE',
  Nevada = 'NV',
  NewHampshire = 'NH',
  NewJersey = 'NJ',
  NewMexico = 'NM',
  NewYork = 'NY',
  NorthCarolina = 'NC',
  NorthDakota = 'ND',
  NorthernMarianaIslands = 'MP',
  Ohio = 'OH',
  Oklahoma = 'OK',
  Oregon = 'OR',
  Palau = 'PW',
  Pennsylvania = 'PA',
  PuertoRico = 'PR',
  RhodeIsland = 'RI',
  SouthCarolina = 'SC',
  SouthDakota = 'SD',
  Tennessee = 'TN',
  Texas = 'TX',
  TrustTerritories = 'TT',
  Utah = 'UT',
  Vermont = 'VT',
  Virginia = 'VA',
  VirginIslands = 'VI',
  Washington = 'WA',
  WestVirginia = 'WV',
  Wisconsin = 'WI',
  Wyoming = 'WY',
}
